import { useOptionsAndAlternatives } from "./useOptionsAndAlternatives";

export const useProductOptions = () => {
	const { data: { productOptionGroup } = {}, ...rest } = useOptionsAndAlternatives();
	return {
		productOptionGroup,
		...rest,
	};
};
